import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      // Retry only transient failures; never 4xx and never 501 (not built).
      retry: (count, error) => {
        if (!isApiError(error)) return false;
        if (error.status === 0 || error.status === 502 || error.status === 503 || error.status === 504) return count < 2;
        return false;
      },
    },
    mutations: {
      // Commands carry idempotency keys; an uncertain outcome is resolved, never blindly retried.
      retry: false,
    },
  },
});

/** Every private query key is scoped by tenant: ['org', orgId, ...]. */
export function orgKey(orgId: string, ...parts: unknown[]): unknown[] {
  return ['org', orgId, ...parts];
}

/** Drop every tenant scoped cache entry (tenant switch, sign out, membership loss). */
export function clearPrivateCaches(): void {
  queryClient.cancelQueries({ queryKey: ['org'] });
  queryClient.removeQueries({ queryKey: ['org'] });
}
